function getProjectAlias (projectId) {
  if (!this.projects) return
  const project = this.projects[projectId]
  if (!project) return
  return project.alias
}

export default getProjectAlias